import React from 'react';
import AuthWrapper from "components/auth-wrapper/AuthWrapper";
import {MainTop} from "components/pages/groups/group-container/main-top/Main-top";
import {OfflineContainer} from "components/pages/offline/offline-container/OfflineContainer";
import './ofline.css'

export const Offline = () => {
    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title={''}
                    payment={false}
                    tabs={false}
                    setting={false}
                    link={'/'}
                />
                <OfflineContainer/>
            </div>
        </AuthWrapper>
    );
};

